import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ColumnChartConfig } from '../../../../../shared/google-chart/Models/ColumnChartConfig';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import * as moment from 'moment';

@Component({
	selector: 'app-ebu-daily-usage-new',
	templateUrl: './ebu-daily-usage-new.component.html',
	styleUrls: ['./ebu-daily-usage-new.component.css']
})
export class EbuDailyUsageNewComponent implements OnInit, OnChanges {
	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() siteBattviewsData: any = {};
	@Input() siteTags: any = {};
	@Input() siteBattviewsTags: any = {};
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	tooltipText='Overview of average EBUs over the selected period of time. Average EBUs are calculated by adding all EBUs and dividing by the number of detected working days.';
	config: ColumnChartConfig;
	title: string='EBU';
	titleEbu: string='EBU Usage';
	filteredData: any;
	tableColumns: any[] = [];
	elementId: string = 'batt_events_ebu_usage_summary_new';

	constructor(
    private commonUtil: CommonUtil

  ) {}

	ngOnInit() {
		this.config = new ColumnChartConfig({
			isPercent: true,
			xTitle: "Daily EBU Usage",
			yTitle: "% Batteries"
		});

		this.config.formatFunction = (data) => {
			data = data.list;
			data = data > 2 ? 2: data;
			return {list: data};
		};
	}

  eventEmit(event: {type: string, data: any}) {
		switch (event.type) {
			case "export":
				let exportFilters = this.commonUtil.getExportWidgetFiltersInfo(event.data);
				let csvData: any = [{
					a: 'Site: '+this.customerName+'/'+this.siteName
				}];
				for(let key in exportFilters) {
					csvData.push({a: exportFilters[key]});
				}
				csvData.push({a: 'Date of print: '+ moment().format('LL')}, {}); // Date of print & an empty row
				csvData.push({a: "Battery Id", b: "Truck Id", c: "Battery SN", d: "EBU"});
				for(let range in this.filteredData) {
					let devices = this.filteredData[range].list;
					devices.forEach((device) => {
						csvData.push({a: device.battery_id, b: device.truck_id, c: device.battery_sn, d: device.value});
					});
				}
				let fileName = `${this.title} - ${this.customerName} / ${this.siteName}`;
				new ngxCsv(csvData, fileName);
				break;

			case "filteredData":
				this.filteredData = event.data;
				break;
		}
	}

	ngOnChanges(changes) {
		if(this.data) {
			let userAlertsSettings = this.data.siteSettings.userSettings;
			if(userAlertsSettings && !userAlertsSettings.bv_inuse_events_only_for_charge_ahr) {
				this.elementId = 'batt_ebu_usage_summary_new';
			}
			this.tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (userAlertsSettings.view_truck_id) {
				this.tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			this.tableColumns.push({title: "Battery SN", property: "battery_sn"});
			this.tableColumns.push({title: "Average EBU", property: "value"});
			this.tableColumns.push({title: "Max EBUs", property: "max_ebu"});

			this.data['battviewsData'] = this.siteBattviewsData;
			this.data['siteTags'] = this.siteTags;
			this.data['siteBattviewsTags'] = this.siteBattviewsTags;
		}
	}
}
